<!-- 由 suu 创建于 2025-03-14 星期五 -->
<template>
  <div class="project-three">
    <div class="project-padding">
      <div class="rule-btn" @click="bindScrollRule">规则</div>
      <!-- 用户信息 -->
      <UserInfo :info="info"></UserInfo>
      <!-- Project清单 -->
      <div class="activity-title">彩蛋任务</div>
      <TaskList :info="info"></TaskList>
      <!-- <img class="not-open-task" v-else
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/c55848c72504ce483270ec4bb6a110b2_wh=1029_495.webp"
        alt=""> -->
      <!-- 奖品说明 -->
      <PrizeList :info="info" @jump="bindToMiniProgram"></PrizeList>
      <!-- 注意事项 -->
      <div class="tips-container">
        <div class="activity-title">注意事项</div>
        <img
          class="tips-image"
          ref="rule"
          src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/35a741f5d5fbb38e8f9c4e92bebb5b24_wh=1029_1278.webp"
          alt=""
        />
      </div>
      <!-- logo -->
      <img
        class="logo"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/2c0b4ce133794284b542847eb7ce6cdd_wh=324_93.webp"
        alt=""
      />
    </div>
    <!-- 底部固定 -->
    <FixedTimeout :info="info" @jump="bindToMiniProgram" />
    <van-overlay :show="showFailToast" @click="showFailToast = false">
      <FailToast @close="showFailToast = false" :info="info" />
    </van-overlay>
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @select="bindSelect"
      zIndex="9999"
    />
  </div>
</template>

<script>
import { eventObj } from '@/components/app/share/share-method.js'
import ShareComponent from '@/components/app/share/share.vue'
import TaskList from './task-list.vue'
import PrizeList from './prize-list.vue'
import UserInfo from './user-info.vue'
import FailToast from './fail-toast.vue'
import FixedTimeout from './fixed-timeout.vue'
export default {
  name: 'project-three',

  components: {
    TaskList,
    PrizeList,
    UserInfo,
    FailToast,
    FixedTimeout,
    ShareComponent
  },

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      showShare: false,
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 5
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 6
        }
      ],
      shareOptions: {
        desc: '限时享400元现金优惠~',
        title: '好友【XXX】邀请您来健萌体验',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/uploads/e2238fb3a5f217f8b89e057ccfbc2bbb.png?v=1'
      },
      taskList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5430ad68bdb5c184dde2ad86d87b9363.webp',
          title: '在APP首次约课',
          exp: 1,
          desc: '活动期间在APP首次约课 (+1经验值)',
          btnText: '去约课',
          status: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5430ad68bdb5c184dde2ad86d87b9363.webp',
          title: '发布挑战记录',
          exp: 2,
          desc: '在圈子发布Project挑战记录 (+2经验值)',
          btnText: '去约课',
          status: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5430ad68bdb5c184dde2ad86d87b9363.webp',
          title: '上传分享截图',
          exp: 5,
          desc: '上传小红书/朋友圈分享截图 (+5经验值)',
          btnText: '去约课',
          status: 1
        }
      ],
      showFailToast: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.init()
    this.$http.get('member/index?a=shareLogPush', {
      from: `project活动-挑战页曝光-${this.$route.query.tfrom || ''}`,
      from_id: 250319
    })
  },

  destroyed() {},

  methods: {
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 5:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 6:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
      }
    },
    init() {
      /* 只显示一次 */
      let isShow = localStorage.getItem('project-activity-fail-toast')
      if (!isShow && [4, 5, 6].includes(this.info.project_state)) {
        this.showFailToast = true
        localStorage.setItem('project-activity-fail-toast', 1)
      }
    },
    bindScrollRule() {
      let el = this.$refs.rule
      if (el) {
        // 获取目标元素相对于视口顶部的距离
        const rect = el.getBoundingClientRect()
        // 获取视口高度
        const windowHeight = window.innerHeight
        // 计算要滚动到屏幕中间的目标位置
        const scrollTop = Math.round(
          window.scrollY + rect.top - windowHeight / 2 + el.offsetHeight / 2
        )
        // 执行滚动操作
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth' // 平滑滚动
        })
      }
    },
    bindToMiniProgram() {
      let url
      let fid = this.info.uid
      let env = this.$http.curEv()
      if (env === 'pro') {
        url = `https://vue.gymcity.com.cn/?path=project-get&fid=${fid}&scope=snsapi_userinfo`
      } else {
        url = `https://test.gymcity.com.cn/?path=project-get&fid=${fid}&scope=snsapi_userinfo`
      }
      this.qrcodeUrl = url
      this.shareOptions.title = `好友${
        this.info.truename || ''
      }邀请您来健萌体验`
      this.showShare = true
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.project-three {
  min-height: 100vh;
  background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/caa2a2a7ca32fd7de09f9dca0fb141df_wh=1125_744.webp');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center top;
  background-color: #ff3b86;

  .project-padding {
    padding: 245px 16px 26px;
  }

  .rule-btn {
    position: fixed;
    z-index: 1;
    right: 0;
    top: 113px;
    width: 22px;
    height: 38px;
    background: rgba(0, 0, 0, 0.29);
    backdrop-filter: blur(10px);
    border-radius: 4px 0px 0px 4px;
    font-size: 12px;
    line-height: 14px;
    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 0px;
  }

  .activity-title {
    text-align: center;
    font-family: MiSans, MiSans;
    font-weight: bold;
    font-size: 26px;
    color: #ffffff;
    line-height: 23px;
    margin-bottom: 11px;
  }

  .tips-container {
    margin-bottom: 26px;

    .tips-image {
      width: 100%;
    }
  }

  .not-open-task {
    width: 100%;
    margin-bottom: 26px;
  }

  .logo {
    width: 105px;
    margin: 0 auto;
  }
}
.wrapper {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  .fail-image {
    width: 275px;
  }
}
</style>
